import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent, MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalViewTradeAgreementComponent } from '../modal-view-trade-agreement/modal-view-trade-agreement.component';
import { ModalViewPaymentComponent } from '../modal-view-payment/modal-view-payment.component';
import { MainService } from 'src/app/services/main.service';
import { ModalViewProductComponent } from '../modal-view-product/modal-view-product.component';
import { ModalViewObjectiveComponent } from '../modal-view-objective/modal-view-objective.component';
import { ModalViewChargeComponent } from '../modal-view-charge/modal-view-charge.component';
import { ModalViewUserComponent } from '../modal-view-user/modal-view-user.component';
import { ModalViewRoleComponent } from '../modal-view-role/modal-view-role.component';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalMessageComponent } from '../modal-message/modal-message.component';
import { ModalViewBranchOffice } from '../modal-view-branch-office/modal-view-branch-office.component';
import { ModalViewAssetLocationComponent } from '../modal-view-asset-location/modal-view-asset-location.component';
import { ModalReturnAssetComponent } from '../modal-return-asset/modal-return-asset.component';
import { ModalAssetHistoryComponent } from '../modal-asset-history/modal-asset-history.component';
import { ModalUserInformationComponent } from '../modal-user-information/modal-user-information.component';
import { ModalViewTradeAgreementComponent2 } from '../modal-view-trade-agreement2/modal-view-trade-agreement2.component';

@Component({
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styles: [
  ]
})

export class CustomTableComponent implements OnInit {

  userPermissions: any = this.uService.userPermissions;
  displayedColumns_aux: string[] = [];

  @Output() actionTrigger = new EventEmitter<{ action: string, row: any }>();

  private _data: any;
  dataSource: MatTableDataSource<any>;

  length = 100;
  pageSize = 20;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  pageEvent: PageEvent;

  rowSelected: any;


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @Output() eventSendRow = new EventEmitter<any>();

  @Input() searchInput: boolean = true;
  @Input() functionalities: string[] = [];
  @Input() displayedColumns: any = [];
  @Input() tableTitle: string = '';
  @Input() id: string = '';

  @Input() set data (value: any) {
    this._data = value;

   if(this._data.length != 0){
    for (let index = 0; index < this._data.length; index++) {
      this._data[index].rowNumber = index + 1;
    }
   }

  this.dataSource = new MatTableDataSource(this.data);
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
  }

  get data(): any {
    return this._data;
  }
  sendRow(row: any){
    this.eventSendRow.emit(row);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  settingsView(id: any){
    this.router.navigate([`/dashboard/settings-business/${id}`]);
  }

  getRowInfo(row: any){
    if(this.checkFunctionality('selectable')){
      this.rowSelected = row;
      this.sendRow(row);
    }
  }

  checkFunctionality( functionality: string ): boolean{
    var result = false;
    this.functionalities.forEach(element => {
      if(functionality.indexOf(element) > -1){
        result = true;
      }
    });

    if(this.userPermissions.organizations_linkser.length > 0){
      result = false;
    }
    return result;
  }

  transformDate(date: string){
    return this.uService.transformDate(date);
  }

  //tradeAgreement actions
  viewTradeAgreement2(commercial_agreements_products: any){
    if(commercial_agreements_products !== null){
      const dialogRef = this.dialog.open(ModalViewTradeAgreementComponent2, {
        // width: '550px',
        disableClose: true,
        data: commercial_agreements_products,
        // panelClass: 'content_modal'
      });
    }else{
      this.toast.error('Este acuerdo no tiene detalles.', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    }
  }

  viewTradeAgreement(id: string){
    this.mService.get_request('commercial-agreements/list', { id })
    .subscribe((resp: any)=>{

      if(resp.status){
        const dialogRef = this.dialog.open(ModalViewTradeAgreementComponent, {
          // width: '550px',
          disableClose: true,
          data: resp.items[0],
          // panelClass: 'content_modal'
        });
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  }

  viewUserInformation(id: string){
    this.mService.get_request('qpos/customer-user', { id })
    .subscribe((resp: any)=>{
      if(resp.status){
        const dialogRef = this.dialog.open(ModalUserInformationComponent, {
          width: '550px',
          disableClose: true,
          data: {
            item: resp.item,
            id_row: id
          },
          // panelClass: 'content_modal'
        });
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  }

  editTradeAgreement(id: string){
    this.router.navigate([`/dashboard/new-trade-agreement/${id}`]);
  }

  editTradeAgreement2(tradeId: string){
    this.router.navigate([`/dashboard/pre-new-trade-agreement/${this.id}/${tradeId}`]);
  }

  editAsset(assetId: string){
    this.router.navigate([`/dashboard/new-asset/${assetId}`]);
  }

  viewAssetLocation(row: any){
    this.dialog.open(ModalViewAssetLocationComponent, {
      disableClose: true,
      data: row,
      panelClass: 'content-medium'
    });
  }

  viewAssetHistory(row: any){
    this.dialog.open(ModalAssetHistoryComponent, {
      disableClose: true,
      data: row,
      panelClass: 'content-medium'
    });
  }

  returnAsset(row: any){
    const dialogRef = this.dialog.open(ModalReturnAssetComponent, {
      disableClose: true,
      data: row,
      panelClass: 'content-medium'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        row.status_raw = result.status;
        row.status = result.status === 'damaged' ? 'Dañado' : 'Disponible';
        row.condition = result.condition;
      }
    });
  }

  viewAssetPickup(row: any){
    this.router.navigate([`/dashboard/asset-pickup/${row.id}`]);
  }

  deleteAsset(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar activo?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mService.delete_request(`assets/${id}`)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });

  }

  // asset types actions
  editAssetType(id: string){
    this.router.navigate([`/dashboard/new-asset-type/${id}`]);
  }

  deleteAssetType(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar tipo de activo?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mService.delete_request(`asset-types/${id}`)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });
  }

  // asset requests actions
  editAssetRequest(id: string){
    this.router.navigate([`/dashboard/new-asset-request/${id}`]);
  }

  deleteAssetRequest(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar solicitud?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mService.delete_request(`asset-requests/${id}`)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });
  }

  deleteTradeAgreement(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar acuerdo comercial?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          id: id
        }
        this.mService.delete_request('commercial-agreements/delete', fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });
  }

  deleteTradeAgreement2(tradeId: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar acuerdo comercial?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          organization_id: this.id
        }
        this.mService.delete_request(`v2/commercial-agreements/${tradeId}`, fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, this.id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });
  }

  // branch offices actions
  viewBranchOffice(id: string){
    this.mService.get_request('branch-office', { id })
    .subscribe((resp: any)=>{
      if(resp.status){
        const dialogRef = this.dialog.open(ModalViewBranchOffice, {
          // width: '550px',
          disableClose: true,
          data: resp.item,
          panelClass: 'content-medium'
        });
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  editBranchOffice(id: string){
    this.router.navigate([`/dashboard/new-branch-office/${this.id}/${id}`]);
  }

  deleteBranchOffice(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar sucursal?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mService.delete_request('branch-office/delete', { id })
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        })
      }
    });
  }

  // payments actions
  viewPayment(id: string){
    this.mService.get_request('full-payment', { id })
    .subscribe((resp: any)=>{
      if(resp.status){
        const dialogRef = this.dialog.open(ModalViewPaymentComponent, {
          // width: '550px',
          disableClose: true,
          data: resp.items[0],
          panelClass: 'content-medium'
        });
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  editPayment(id: string){
    this.router.navigate([`/dashboard/new-payment/${id}`]);
  }

  deletePayment(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar pago?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.mService.delete_request('payments/delete', { id })
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        })
      }
    });
  }

  // shops actions
  redirectShop(id: string, active: boolean, event: any){
    if(!event.target.classList.contains('icon-btn')){
      if(active){
        this.router.navigate([`/dashboard/business-details/${id}`]);
      }
    }
  }

  redirectShopV2(id: string){
    this.router.navigate([`/dashboard/business-details/${id}`]);
  }

  editShop(id: string){
    this.router.navigate([`/dashboard/new-business/${id}/step-1/`]);
  }

  deleteShop(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar comercio?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          id: id
        }
        this.mService.delete_request('organizations/delete', fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'organization_id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    })
  }

  //products actions
  deleteProduct(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar producto?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          id: id
        }
        this.mService.delete_request('product/delete', fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });
  }

  editProduct(id: string){
    this.router.navigate([`/dashboard/new-product/${id}/step-1/`]);
  }

  viewProduct(id){
    this.mService.get_request('product', { id })
    .subscribe((product: any)=>{
      if(product.status){
        var provider_ids: any = [];
        product.item.product_provider.forEach(product_provider => {
          provider_ids.push(product_provider.provider_id);
        });
        var productToReturn = {
          ...product.item,
          base_price: product.item.product_provider[0]?.base_price,
          product_cost: product.item.product_provider[0]?.product_cost,
          provider_ids: provider_ids,
        }
        const dialogRef = this.dialog.open(ModalViewProductComponent, {
          // width: '550px',
          disableClose: true,
          data: productToReturn,
          panelClass: 'content-medium'
        });

      }else{
        this.toast.error(product.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(product.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  // charge options
  viewCharge(row: any){
    // this.mService.get_request('due-payment', { id })
    // .subscribe((resp: any)=>{
    //   if(resp.status){

    //     var duePaymentToReturn:any = {
    //       commercial_agreement_id: resp.item[0].commercial_agreement_id,
    //       amount: resp.item[0].due_payment_amount,
    //       max_payment_date: resp.item[0].due_payment_max_payment_date,
    //       status: resp.item[0].due_payment_status
    //     }
    //     const dialogRef = this.dialog.open(ModalViewChargeComponent, {
    //       // width: '550px',
    //       disableClose: true,
    //       data: duePaymentToReturn,
    //       panelClass: 'content-medium'
    //     });
    //   }else{
    //     this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    //     if(resp.message.includes('expirado')){
    //       this.uService.logOut$.next(true);
    //     }
    //   }
    // })

    const dialogRef = this.dialog.open(ModalViewChargeComponent, {
      // width: '550px',
      disableClose: true,
      data: row,
      panelClass: 'content-medium'
    });
  }

  editCharge(id: string){
    this.router.navigate([`/dashboard/new-charge/${id}/step-1/`]);
  }

  deleteCharge(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar deuda?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          id: id
        }
        this.mService.delete_request('due-payment/delete', fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    });
  }

  // user options
  viewUser(id: string){
    this.mService.get_request('users/list-id', { id })
    .subscribe((resp: any)=>{
      if(resp.status){
        const dialogRef = this.dialog.open(ModalViewUserComponent, {
          // width: '550px',
          disableClose: true,
          data: resp.items,
          panelClass: 'content-medium'
        });
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  editUser(id: string){
    this.router.navigate([`/dashboard/new-user/${id}`]);
  }

  deleteUser(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar usuario?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          id: id
        }
        this.mService.delete_request('users/delete', fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    })
  }

  // roles options
  viewRole(id: string){
    this.mService.get_request('rol/list/', { id: 1 })
    .subscribe((resp: any)=>{
      if(resp.status){
        const dialogRef = this.dialog.open(ModalViewRoleComponent, {
          // width: '550px',
          disableClose: true,
          data: {
            permissions: resp.items.superadmin.permissions,
            id
          },
          panelClass: 'content-sm'
        });
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  editRole(id: string){
    this.router.navigate([`/dashboard/new-role/${id}`]);
  }

  deleteRole(id: string){
    const dialogRef = this.dialog.open(ModalMessageComponent, {
      // width: '550px',
      disableClose: true,
      panelClass: 'content-fit',
      data: {
        title: '¿Eliminar rol?'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        var fields: any = {
          id: id
        }
        this.mService.delete_request('rol/delete', fields)
        .subscribe((resp: any)=>{
          if(resp.status){
            this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
            this.deleInternal(this.data, id, 'role_id');
          }else{
            this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true})
          }
        });
      }
    })
  }

  // general actions
  deleInternal(array: any, id: string, fieldName: string){
    for (let index = 0; index < array.length; index++) {
      const element = array[index];

      if(element[`${fieldName}`] == id){
        array.splice(index, 1);
      }
    }

    if(array.length != 0){
      for (let index = 0; index < array.length; index++) {
        array[index].rowNumber = index + 1;
      }
    }

    this.dataSource = new MatTableDataSource(array);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  stringSetClass(string: string, id: string){
    var columnID: any = document.getElementById(`col-${id}`);;
    var htmlToReturn: string = '';

    if(string != '---'){

      var htmlElem: string;
      var strings: any = string.split(',');
      var more: string = '';
      var addStrings: boolean = true;

      for (let index = 0; index < strings.length; index++) {
        const subString = strings[index];
        if(addStrings){
          if(index > 2){
            more = `<div class="badge !w-fit">+${strings.length - 3}</div>`;
            htmlToReturn += more;
            addStrings = false;
          }else{
            var badgeClass: string = '';
            if(subString.toLowerCase().includes('listado')){
              badgeClass = 'purple';
            }
            if(subString.toLowerCase().includes('creaci')){
              badgeClass = 'sky';
            }
            if(subString.toLowerCase().includes('edici')){
              badgeClass = 'darkPurple';
            }
            if(subString.toLowerCase().includes('reportes')){
              badgeClass = 'lightGreen';
            }
            htmlElem = `<div class="badge ${badgeClass}">${subString}</div>`;
            htmlToReturn += htmlElem;
          }
        }
      }
    }
    columnID.innerHTML = htmlToReturn;
  }

  constructor( public _MatPaginatorIntl: MatPaginatorIntl, private uService: UtilsService, public dialog: MatDialog, private router: Router, private toast: ToastrService, private mService: MainService) {
  }

  ngOnInit(): void {
    // this.displayedColumns.unshift({variable: 'rowNumber', displayedName: 'N.'})
    this.displayedColumns.forEach(element => {
      this.displayedColumns_aux.push(element.variable);
    });
    this._MatPaginatorIntl.itemsPerPageLabel = 'Items por página';
    this._MatPaginatorIntl.previousPageLabel = 'Anterior';
    this._MatPaginatorIntl.nextPageLabel = 'Siguiente';
  }

  viewObjective(row: any) { 
    this.actionTrigger.emit({ action: 'view', row: row });
  }

  editObjective(row: any) { // 👈 Debe recibir 'row' completo
    this.actionTrigger.emit({ action: 'edit', row: row });
  }

  deleteObjective(row: any) {
    this.actionTrigger.emit({ action: 'delete', row: row });
  }

  viewArrivedData(row: any) {
    this.actionTrigger.emit({ action: 'view-arrived', row: row });
  }
}
